import { IsNotEmpty, IsInt } from "class-validator";

import { ISiteLicense } from "./site-license.interface";

export class SiteLicenseDto implements ISiteLicense {
  @IsNotEmpty()
  site: string;

  @IsNotEmpty()
  @IsInt()
  count: number;
}
